import { get } from '@alltrails/core/utils/get';
import List from '../types/List';
import ListItems from '../types/ListItems';

export type ListsAndListItemsResponse = {
  lists: {
    lists: List[];
    listItems: ListItems;
  };
};

const getListsAndListItems = async () => {
  const {
    lists: { lists, listItems }
  } = await get<ListsAndListItemsResponse>('/api/alltrails/web/lists');
  return { lists, listItems };
};

export default getListsAndListItems;
